import type { User } from 'features/users/types';
import type { TelephonyUser } from 'features/sip/types';
import parsePhoneNumber from 'libphonenumber-js';

export const getUserDisplayName = (user: User | TelephonyUser): string => {
  if (user.name) {
    return user.name;
  }

  if ('phoneNumber' in user && user.phoneNumber) {
    try {
      const parsed = parsePhoneNumber(user.phoneNumber);
      return parsed?.formatInternational() || user.phoneNumber;
    } catch (e) {
      return user.phoneNumber;
    }
  }

  return '';
};
